import { set_storage } from "@/utils/util";
window.log = console.log.bind(console);

export function userRole(role) {
    return set_storage("user-role", role);
}
